const headerComponent = document.getElementsByClassName('header')[0];
const body = document.querySelector('body');
const headerToggle = document.querySelector('.header-toggle');

// Header scroll
if (headerComponent) {
  // menu handlers

  // check mobile menu show/hide condition
  const mobileMenuStartPoint = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
          '--mobile-menu-start-point'
      )
  );
  let isMobileMenuEnable =
      window.outerWidth <= mobileMenuStartPoint ||
      document.querySelector('.header-mobile');

  // toggle menu handler
  function menuToggleFunc() {
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');

    headerComponent.classList.toggle('is-open-menu');
    menuToggle?.classList.toggle('active');
    navbarNav?.classList.toggle('active');
    headerCloseWrapper?.classList.toggle('active');
    headerToggle?.classList.toggle('is-open-menu')
    body?.classList.toggle('is-open-menu');


    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (scrollLock.getScrollState()) {
      scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
      scrollLock.addScrollableSelector('.simplebar-content-wrapper');
    } else {
      scrollLock.enablePageScroll();
    }
  }

  // menu update function
  function updateMenu() {
    isMobileMenuEnable =
        window.outerWidth <= mobileMenuStartPoint ||
        document.querySelector('.mobile-header');

    if (!isMobileMenuEnable) {
      const headerCloseWrapper = document.querySelector(
          '.header-close-wrapper'
      );
      headerCloseWrapper.classList.remove('active');

      const activeMenuItems = document.querySelectorAll('.menu-item.active');
      activeMenuItems.forEach((item) => {
        item.classList.remove('active');
      });

      const navbarNav = document.querySelector('.navbar-nav');
      navbarNav.classList.remove('active');

      const menuToggle = document.querySelector('.menu-toggle');
      menuToggle.classList.remove('active');

      headerComponent?.classList.remove('is-open-menu');
      body.classList.remove('is-open-menu');

      // LockScroll when burger open and enable when closed
      scrollLock.enablePageScroll();
    }
  }

  const menuToggle = document.querySelector('.menu-toggle');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');

  menuToggle.addEventListener('click', menuToggleFunc);
  headerCloseWrapper.addEventListener('click', menuToggleFunc);

  // end of toggle menu handler

  const menuDropdownsArr = headerComponent.querySelectorAll('.menu-dropdown');
  const menuDropdownBg = headerComponent.querySelector('.header__dropdown-bg');
  const menuDropdownBottomBg = headerComponent.querySelector('.header__bottom-dropdown-bg');

  const DESKTOP_BREAKPOINT = 1200;

  let activeDropdown = null;

  function setBgHeightFromDropdown(dropdown) {
    if (window.innerWidth <= DESKTOP_BREAKPOINT || !menuDropdownBg) return;

    const list = dropdown.querySelector('.menu-dropdown__list');
    if (!list) return;

    const headerRect = headerComponent.getBoundingClientRect();
    const listRect = list.getBoundingClientRect();

    const height = listRect.bottom - headerRect.top;
    menuDropdownBg.style.height = `${height + 48}px`;
  }

  function openDropdown(current) {
    menuDropdownsArr.forEach(dd => {
      dd.classList.toggle('is-open', dd === current);
    });

    if (menuDropdownBg) {
      menuDropdownBg.classList.add('is-visible');
      menuDropdownBottomBg.classList.add('is-visible');
      setBgHeightFromDropdown(current);
    }
  }

  function closeAllDropdowns() {
    menuDropdownsArr.forEach(dd => dd.classList.remove('is-open'));
    activeDropdown = null;

    if (menuDropdownBg) {
      menuDropdownBg.classList.remove('is-visible');
      menuDropdownBottomBg.classList.remove('is-visible');
      menuDropdownBg.style.height = `var(--header-height)`;
    }
  }

// — Hover (только 1200+) —
  menuDropdownsArr.forEach(menuDropdown => {
    menuDropdown.addEventListener('mouseenter', () => {
      if (window.innerWidth > DESKTOP_BREAKPOINT) {
        openDropdown(menuDropdown);
      }
    });
  });

// leave header (только 1200+)
  headerComponent.addEventListener('mouseleave', () => {
    if (window.innerWidth > DESKTOP_BREAKPOINT) {
      closeAllDropdowns();
    }
  });

// — Click (только < 1200) —
  menuDropdownsArr.forEach(menuDropdown => {
    // Кнопка закрытия дропдауна
    const btn = menuDropdown.querySelector('.menu-dropdown__btn');
    if (btn) {
      btn.addEventListener('click', (e) => {
        if (window.innerWidth > DESKTOP_BREAKPOINT) return;
        e.stopPropagation();
        closeAllDropdowns(); // activeDropdown = null внутри, переход снова будет блокироваться
      });
    }

    menuDropdown.addEventListener('click', (e) => {
      if (window.innerWidth > DESKTOP_BREAKPOINT) return;

      if (activeDropdown === menuDropdown) {
        // Второй клик по тому же — разрешаем переход
        return;
      }

      // Кликнули по новому (или первый раз)
      e.preventDefault();

      // Если был открыт другой — сбрасываем
      if (activeDropdown && activeDropdown !== menuDropdown) {
        activeDropdown.classList.remove('is-open');
      }

      activeDropdown = menuDropdown;
      openDropdown(menuDropdown);
    });
  });

  // Hide and show Header when scroll up
  function headerSticky() {
    let prevScrollPos = window.pageYOffset;

    document.onscroll = () => {
      const currentScrollPos = window.pageYOffset;
      const headerHeight = headerComponent.scrollHeight;

      if (window.scrollY > 0) {
        if (prevScrollPos > currentScrollPos) {
          headerComponent.style.top = 0;
          headerComponent.classList.add('scrolled');
        } else {
          headerComponent.style.top = `-${headerHeight + 3}px`;
        }
      }

      if (window.scrollY === 0) {
        headerComponent.classList.remove('scrolled');
      }

      prevScrollPos = currentScrollPos;
    };

    if (window.scrollY !== 0) {
      headerComponent.classList.add('scrolled');
    }
  }

  headerSticky();
}
